/**
* inputFilter widget
*
* Events:
* keyignored
* keytyped
*/

import $ from 'jquery';
import def from './inputFilter.def.js';

$.widget('formBuilder.inputFilter', def);



// WEBPACK FOOTER //
// ./src/widgets/inputFilter.js